import { httpClient } from '../http/httpClient'

export type GetConfigsAppResponse = {
  customers: boolean
  unico: boolean
  cdnUrl: string
  inviteUrl: string
  supportUrl: string
  termUrl: string
  validationUrl: string
  name: string
  baseUrl: string
  links: boolean
  INVITE_URL: string
  ADMIN_WITHDRAW: boolean
  SHOW_PIN: boolean
  SHOW_LEADS_PAGE: boolean
  SHOW_RADAR_PAGE: boolean
  SHOW_MANAGER_PAGE: boolean
  CAN_REGISTER_SELLER: boolean
  CAN_REGISTER: boolean
  CAN_SEND_NOTIFICATION: boolean
  callStart?: boolean
}

export const getConfigsApp = async () => {
  const { data } = await httpClient
    .get<GetConfigsAppResponse>('/config/app')
    .catch((error) => {
      throw error?.response?.data || error
    })

  return data
}
